import UpdateTicker from "./components/UpdateTicker";
import SiteHeader from "./components/SiteHeader";
import HeroSection from "./components/HeroSection";
import FeaturedSpot from "./components/FeaturedSpot";
import CollectionIndex from "./components/CollectionIndex";
import StreamTimeline from "./components/StreamTimeline";
import CoverWall from "./components/CoverWall";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <UpdateTicker />
      <SiteHeader />
      <main className="w-full">
        <HeroSection />
        <FeaturedSpot />
        <CollectionIndex />
        <StreamTimeline />
        <CoverWall />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}